import { useFormik } from "formik";
import axios from "axios";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import Layout from "../assets/component/Layout";
import { useNavigate } from "react-router-dom";

export const BASE_URL = process.env.REACT_APP_API_URL
export const BASE_URL_FILE = process.env.REACT_APP_FILE_BASE_URL

export default function AdmissionApplication() {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      fullName: "",
      dateOfBirth: "",
      previousEducation: "",
      courseApplied: "",
      feeBreakdown: "",
      paymentMode: "",
      transactionId: "",
      dateOfPayment: "",
    },
    onSubmit: async (values) => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(`${BASE_URL}create-admission`, values,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (response.status === 200) {
          navigate("/engineers-forms");
        } else {
          // setApiError("Login failed. Please try again.");
        }

      } catch (error) {
        console.error("Submission error:", error);
      }
    },
  });

  return (
    <Layout>
      <section className="Inner-page-layout">
        <div>
          <h1>Admission Application Form</h1>
          <div className="application-forms-cards">
            <Container>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={4}>
                    <div className="form-input-item">
                      <Form.Group className="mb-3">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="fullName"
                          placeholder="Type here..."
                          onChange={formik.handleChange}
                          value={formik.values.fullName}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="form-input-item">
                      <Form.Group className="mb-3">
                        <Form.Label>Date of Birth</Form.Label>
                        <Form.Control
                          type="date"
                          name="dateOfBirth"
                          onChange={formik.handleChange}
                          value={formik.values.dateOfBirth}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="form-input-item">
                      <Form.Group className="mb-3">
                        <Form.Label>Previous Education Details</Form.Label>
                        <Form.Control
                          type="text"
                          name="previousEducation"
                          placeholder="Type here..."
                          onChange={formik.handleChange}
                          value={formik.values.previousEducation}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="form-input-item">
                      <Form.Group className="mb-3">
                        <Form.Label>Course Applied For</Form.Label>
                        <Form.Control
                          type="text"
                          name="courseApplied"
                          placeholder="Type here..."
                          onChange={formik.handleChange}
                          value={formik.values.courseApplied}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="form-input-item">
                      <Form.Group className="mb-3">
                        <Form.Label>Fee Breakdown (Tuition, Hostel, Exam, etc.)</Form.Label>
                        <Form.Control
                          type="text"
                          name="feeBreakdown"
                          placeholder="Type here..."
                          onChange={formik.handleChange}
                          value={formik.values.feeBreakdown}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="form-input-item">
                      <Form.Group className="mb-3">
                        <Form.Label>Mode of Payment (Cash/Online/DD)</Form.Label>
                        <Form.Control
                          type="text"
                          name="paymentMode"
                          placeholder="Type here..."
                          onChange={formik.handleChange}
                          value={formik.values.paymentMode}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="form-input-item">
                      <Form.Group className="mb-3">
                        <Form.Label>Transaction ID</Form.Label>
                        <Form.Control
                          type="text"
                          name="transactionId"
                          placeholder="Type here..."
                          onChange={formik.handleChange}
                          value={formik.values.transactionId}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="form-input-item">
                      <Form.Group className="mb-3">
                        <Form.Label>Date of Payment</Form.Label>
                        <Form.Control
                          type="date"
                          name="dateOfPayment"
                          onChange={formik.handleChange}
                          value={formik.values.dateOfPayment}
                        />
                      </Form.Group>
                    </div>
                  </Col>
                </Row>

                <div>
                  <Button type="submit">Save</Button>
                </div>
              </Form>
            </Container>
          </div>
        </div>
      </section>
    </Layout>
  );
}





// import { useState } from "react";
// import Form from "react-bootstrap/Form";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import Layout from "../assets/component/Layout";
// import { Col, Container, Row } from "react-bootstrap";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";

// export default function AdmissionApplication() {
//   const Navigate = useNavigate();
//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   return (
//     <Layout>
//       <section className="Inner-page-layout">
//         <div className="">
//           <h1>Admission Application Form</h1>
//           <div className="application-forms-cards">
//             <Container>
//               <Form>
//                 <Row>
//                   <Col lg={4}>
//                     <div className="form-input-item">
//                       <Form.Group className="mb-3" controlId="formBasicEmail">
//                         <Form.Label>Full Name</Form.Label>
//                         <Form.Control type="text" placeholder="Type here..." />
//                       </Form.Group>
//                     </div>
//                   </Col>
//                   <Col lg={4}>
//                     <div className="form-input-item">
//                       <Form.Group className="mb-3" controlId="formBasicEmail">
//                         <Form.Label>Date of Birth</Form.Label>
//                         <Form.Control type="text" placeholder="Type here..." />
//                       </Form.Group>
//                     </div>
//                   </Col>
//                   <Col lg={4}>
//                     <div className="form-input-item">
//                       <Form.Group className="mb-3" controlId="formBasicEmail">
//                         <Form.Label>Previous Education Details</Form.Label>
//                         <Form.Control type="text" placeholder="Type here..." />
//                       </Form.Group>
//                     </div>
//                   </Col>
//                   <Col lg={4}>
//                     <div className="form-input-item">
//                       <Form.Group className="mb-3" controlId="formBasicEmail">
//                         <Form.Label>Course Applied For</Form.Label>
//                         <Form.Control type="text" placeholder="Type here..." />
//                       </Form.Group>
//                     </div>
//                   </Col>
//                   <Col lg={4}>
//                     <div className="form-input-item">
//                       <Form.Group className="mb-3" controlId="formBasicEmail">
//                         <Form.Label>
//                           Fee Breakdown (Tuition, Hostel, Exam, etc.)
//                         </Form.Label>
//                         <Form.Control type="text" placeholder="Type here..." />
//                       </Form.Group>
//                     </div>
//                   </Col>
//                   <Col lg={4}>
//                     <div className="form-input-item">
//                       <Form.Group className="mb-3" controlId="formBasicEmail">
//                         <Form.Label>
//                           Mode of Payment (Cash/Online/DD)
//                         </Form.Label>
//                         <Form.Control type="text" placeholder="Type here..." />
//                       </Form.Group>
//                     </div>
//                   </Col>
//                   <Col lg={4}>
//                     <div className="form-input-item">
//                       <Form.Group className="mb-3" controlId="formBasicEmail">
//                         <Form.Label>Transaction ID</Form.Label>
//                         <Form.Control type="text" placeholder="Type here..." />
//                       </Form.Group>
//                     </div>
//                   </Col>
//                   <Col lg={4}>
//                     <div className="form-input-item">
//                       <Form.Group className="mb-3" controlId="formBasicEmail">
//                         <Form.Label>Date of Payment</Form.Label>
//                         <Form.Control type="text" placeholder="Type here..." />
//                       </Form.Group>
//                     </div>
//                   </Col>
//                 </Row>
//               </Form>
//               <div className="">
//                 <button onClick={handleShow}>Save</button>
//               </div>
//             </Container>
//           </div>
//         </div>
//       </section>
//       <Modal show={show} onHide={handleClose} className="application-modal">
//         <Modal.Body>
//           <div className="">
//             <h2>Submission Options</h2>
//             <p>Enter Email Address to Receive Report (PDF )</p>
//             <Form>
//               <Form.Group className="mb-3" controlId="formBasicEmail">
//                 <Form.Label>Email Address</Form.Label>
//                 <Form.Control type="text" placeholder="Email Address" />
//               </Form.Group>
//               <Form.Group className="mb-3" controlId="formBasicEmail">
//                 <Form.Label>Select</Form.Label>
//                 <Form.Check type="checkbox" label="PDF" />
//               </Form.Group>
//               <button>Submit</button>
//             </Form>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </Layout>
//   );
// }

